export class TransportError extends Error {
    constructor(message) {
        super(message);
        this.name = "TransportError";
    }
    static notConnected() {
        return new TransportError("Transport is not connected");
    }
}
